<main>
    <app-left-nav></app-left-nav>
    <div class="interior-container surface-100 dark:surface-900">
        <router-outlet></router-outlet>
    </div>
</main>
